/* eslint-disable @typescript-eslint/naming-convention */
'use client';
import { Typography } from '@gds/Typography/Typography';
import { useModal } from '@modal/Hooks/UseModal';

import { RichText } from '@page-builder/Components/RichText/RichText';

import styles from './HeycarConnectDealerWrapper.module.css';

interface HeycarConnectModalProps {
  richText: string;
  strings: Record<string, string>;
}

export const HeycarConnectModal = ({ richText, strings }: HeycarConnectModalProps) => {
  const { openModal } = useModal();

  const handleOpenModal = () => {
    openModal(<RichText richText={richText} />, {
      header: strings.modalHeader,
      modalClassName: styles.modalContainer,
      modalBodyClassName: styles.modalBody,
    });
  };

  return (
    <Typography
      className={styles.connectModalCta}
      variant={'subheading3'}
      onClick={handleOpenModal}
    >
      {strings.modalButtonCta}
    </Typography>
  );
};
